import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {
  Row,
  Col,
  Button,
  Input,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';
import Alert from 'react-s-alert';
import * as MyAPI from '../../utils/MyAPI'
// import * as UserActions from '../../actions/UserActions'
// import { LOCAL_STRAGE_KEY } from '../../utils/Settings'
// // https://liapoc.com/recaptcha.html
// // https://www.google.com/recaptcha/intro/v3.html
import ReCAPTCHA from "react-google-recaptcha";
import * as helpers from '../../utils/Helper'
import { useDispatch } from "react-redux";
import Checkbox from '@material-ui/core/Checkbox';

// CreateAccountForm
const CreateAccountForm = (props) => {

  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [accountType, setAccountType] = useState("eval_user");
  let [recaptcha, setRecaptcha] = useState(false)
  let [termChecked, setTermChecked] = useState(false)

  // let dispatch = useDispatch();
  let navigate = useNavigate();

  // submit
  let _onSubmit = async () => {

    props.setLoading(true)

    try {

      if (termChecked !== true) {
        throw Error("規約に合意する必要があります")
      }

      // ReCAPTCHA
      if ( props.source !== "admin" && window.location.hostname !== "localhost" ) {
        if (recaptcha === false) {
          throw Error("ReCAPTCHA is not valid")
        }
      }

      if (helpers.validateEmail(email) !== true ){
        throw Error("email is not valid.")
      }
      let _passChk = helpers.validatePassword(password)
      if ( _passChk ){
        throw Error("password is not valid. ", _passChk)
      }

      let _source = "default"
      if ( props.source ) {
        _source = props.source
      }

      // sign in with password
      let _results = await MyAPI.createAccount({
        email: email,
        password: password,
        source: _source,
        account_type: accountType,
        admin_login_token: props.adminLoginToken,
      })
      if (_results.status !== 'success') {
        throw Error(_results.message)
      }

      props.setLoading(false)

      // redirect to dashboard if user come from website
      if ( props.source !== "admin" ) {
        // redirect
        navigate("/pre_registration")
      } else {
        props.accountCreated()
      }

    } catch (err) {
      console.log("err:", err)

      props.setLoading(false)

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }


  }

  let _onCaptchaChange = (value) => {
    setRecaptcha(value)
  }

  let _handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  let _handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  // _handleAccountTypeChange
  let _handleAccountTypeChange = (e) => {
    setAccountType(e.target.value)
  }

  // _termsChanged
  let _termsChanged = (e) => {

    setTermChecked(e.target.checked)
  }

  return (
    <div>

      {/* email */}
      <Row style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md="3" xs="12" />
        <Col md="6" xs="12" style={{ textAlign: 'left' }}>

          <div className="shadow2dp" style={{
            backgroundColor: '#ffffff',
            padding: 20,
          }}>

            <Row style={{
              marginTop: 10,
              marginBottom: 10,
            }}>
              <Col md="12" xs="12">
                <span>email</span><br/>
                <Input
                  type="email"
                  style={{width: '100%'}}
                  name='email'
                  onChange={_handleEmailChange}
                  value={email}
                  placeholder='steeve@example.com' />
              </Col>
            </Row>

            <Row style={{
              marginTop: 10,
              marginBottom: 20,
            }}>
              <Col md="12" xs="12">
                <span>password</span><br/>
                <Input
                  style={{width: '100%'}}
                  type="password"
                  name='password'
                  onChange={_handlePasswordChange}
                  value={password}
                  placeholder='********' />
              </Col>
            </Row>

            {props.source !== "admin" && (
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Col md="12" xs="12">
                  <ReCAPTCHA
                      sitekey="6Let_UcaAAAAAMnhRDJCtnlbe0cpgJYRwqEzaAaW"
                      onChange={_onCaptchaChange}
                    />
                </Col>
              </Row>
            )}

            {props.source === "admin" && (
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Col md="12" xs="12">
                <span>account type:</span><br/>
                  <Input
                    style={{width: '100%'}}
                    type="accountType"
                    name='accountType'
                    onChange={_handleAccountTypeChange}
                    value={accountType} />
                </Col>
              </Row>
            )}

            {/* kiyaku */}
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col md="12" xs="12">
                <Checkbox
                  checked={termChecked}
                  onChange={_termsChanged}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <Link to="/terms_of_use">利用規約</Link>に合意する
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 10,
            }}>
              <Col md="12" xs="12">
                <Button
                  onClick={_onSubmit}
                  color="primary"
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                  }}>
                  アカウントの作成
                </Button>
              </Col>
            </Row>

          </div>

        </Col>
        <Col md="3" xs="12" />
      </Row>

    </div>
  )
}

export default CreateAccountForm
